//src/components/UI/Modal.jsx

import CloseButton from "./CloseButton";

export default function Modal({ isOpen, title, children, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm p-4">
      
      <div className="
        relative 
        w-full 
        max-w-2xl 
        max-h-[90vh] 
        flex 
        flex-col 
        rounded-3xl 
        bg-white 
        shadow-2xl 
        border 
        border-gray-100 
        overflow-hidden
      ">

        <CloseButton onClick={onClose} />

        {/* HEADER */}
        {title && (
          <div className="px-8 pt-8 pb-4 border-b text-center">
            <h2 className="text-2xl font-semibold tracking-tight text-gray-900">
              {title}
            </h2>
          </div>
        )}

        {/* BODY (СКРОЛЛ ТУТ) */}
        <div className="px-8 py-6 overflow-y-auto flex-1">
          {children}
        </div>

      </div>

    </div>
  );
}